import { render, staticRenderFns } from "./ExportSostamByUM.vue?vue&type=template&id=228adcc2"
import script from "./ExportSostamByUM.vue?vue&type=script&lang=js"
export * from "./ExportSostamByUM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports